import React from 'react';
import GlobalHeader from './GlobalHeader';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <GlobalHeader />
      <main className="p-6">
        {children}
      </main>
    </div>
  );
};

export default MainLayout;
